import React, { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { BankingEntitiesBankAccountNumberFormatEnum } from 'generated/resources/datatable.graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'
import { CompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'

import FormSection from '../FormSection'
import BankSection from './BankSection'
import TaxesSection from './TaxesSection'

interface Props {
  employee: Employee
  canEdit: boolean
}

export interface BankInformationValues {
  accountNumber: string
  complementaryData: string
  format: BankingEntitiesBankAccountNumberFormatEnum
  employeeId: number
}

export interface PayrollInformationValues {
  irpf: number
}

const PayrollInformation: React.FC<Props> = ({ employee, canEdit }) => {
  const companyInstallations = useLazyRef(() => new CompanyInstallations()).current
  const { loading } = useAsyncData(() => Promise.all([companyInstallations.fetch()]), [])
  const [bankShowSubmit, setBankShowSubmit] = useState(false)
  const [taxShowSubmit, setTaxShowSubmit] = useState(false)
  const [[submitBankEventHandler], setSubmitBankEventHandler] = useState<[() => void] | [null]>([
    null,
  ])
  const [[submitTaxEventHandler], setSubmitTaxEventHandler] = useState<[() => void] | [null]>([
    null,
  ])

  const handleSubmit = () => {
    submitBankEventHandler?.()
    submitTaxEventHandler?.()
  }

  return (
    <FormSection
      title={i18n.t('employee_form.payroll_section.title')}
      description={i18n.t('employee_form.payroll_section.description')}
      illustration="payroll-process"
      submitAction={() => handleSubmit()}
      disabled={!bankShowSubmit && !taxShowSubmit}
    >
      {loading && <Loading />}
      {!loading && (
        <Box gap="s24">
          <BankSection
            employee={employee}
            readonly={!canEdit}
            setSubmitEventHandler={(onSubmit: (() => void) | null) =>
              setSubmitBankEventHandler([onSubmit])
            }
            setBankShowSubmit={setBankShowSubmit}
          />
          <TaxesSection
            employee={employee}
            readonly={!canEdit}
            setSubmitEventHandler={(onSubmit: (() => void) | null) =>
              setSubmitTaxEventHandler([onSubmit])
            }
            setTaxShowSubmit={setTaxShowSubmit}
          />
        </Box>
      )}
    </FormSection>
  )
}

export default observer(PayrollInformation)
